/* eslint-disable import/order */
import '@/@iconify/icons-bundle'
import App from '@/App.vue'
import layoutsPlugin from '@/plugins/layouts'
import vuetify from '@/plugins/vuetify'
import {loadFonts} from '@/plugins/webfontloader'
import router from '@/router'
import '@core/scss/template/index.scss'
import '@styles/styles.scss'
import {createPinia} from 'pinia'
import {createApp} from 'vue'
import { vMaska } from 'maska/vue'
import VueHotjar from 'vue-hotjar-next'
import VueGtag from "vue-gtag-next";
import * as Sentry from "@sentry/vue";

loadFonts();

// Create vue app
const app = createApp(App)

if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [
            new Sentry.BrowserTracing({
                // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
                tracePropagationTargets: ["localhost", /^https:\/\/api\.mobicard\.com\.ua/],
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            }),
            new Sentry.Replay(),
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

// Use plugins
app.directive('maska', vMaska)
app.use(vuetify)
app.use(createPinia())
app.use(router)
app.use(layoutsPlugin)

// app.use(VueGtag, {
//     property: {
//         id: 'G-SSH907XTF5'
//     }
// });

// app.use(VueHotjar, {
//     id: 3481412,
//     isProduction: true,
//     snippetVersion: 6
// });

// Mount vue app
app.mount('#app')
